import useModal from "@/@core/components/base-modal/hooks/useModal";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import documentModel from "@/models/document/document";
import router from "@/router";
import store from "@/store";
import useDynamicFields from "@/views/components/dynamic-fields/hooks/useDynamicFields";
import {
  getCurrentInstance,
  onBeforeMount,
  reactive,
  ref,
  watch,
  computed,
} from "@vue/composition-api";

export default function useDocumentInformation(props) {
  const vm = getCurrentInstance().proxy;
  const { resolveFields } = useDynamicFields();
  const { openModal, closeModal } = useModal();
  const {
    openErrorModal,
    openSuccessModal,
    openDefaultErrorModal,
    openWarningModal,
  } = useValidationModal();

  const { fetchDocumentDetail, fetchDocumentEdit } = documentModel();

  const isConfirm = ref(false);

  const loading = reactive({
    save: false,
    approve: false,
    reject: false,
    cancelProcess: false,
  });

  const modalType = reactive({
    confirm: false,
    reject: false,
  });

  const formData = reactive({
    containerId: 0,
    documentId: 0,
    formId: 0,
    status: 1,
    statusLabel: "",
    docType: "",
    docTypeLabel: "",
    docDate: "",
    docNo: "",
    orderDate: "",
    mobileNo: "",
    customerName: "",
    remark1: "",
    remark2: "",
    itfRef1: "",
    itfRef2: "",
    itfExtra: "",
    information: { payload: [], key: [] },
    imageList: [],
    storeName: "",
    dateTime: "", //CreatedTime
    totalPoint: 0,
    totalSpending: 0,
    reJectId: 0,
    rejectReason: "",
    receiptNo: "",
    otherReason: "",
    pointEarn: 0,
  });

  const resolveStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Pending";
      case 5:
        return "Completed";
      case 9:
        return "Rejected";
      default:
    }
  };

  const resolveStatusClass = (status) => {
    switch (status) {
      case 1:
        return "status-pending";
      case 5:
        return "status-complete";
      case 9:
        return "status-reject";
      default:
    }
  };

  const rejecOptionData = ref([
    { label: "ไม่เห็นเลขที่ใบเสร็จ", value: 1 },
    { label: "ไม่ใช่สินค้าที่ร่วมรายการ", value: 2 },
    { label: "ไม่ใช่รูปบิลใบเสร็จ", value: 3 },
    { label: "ใบเสร็จไม่ชัดเจน", value: 4 },
    { label: "ใบเสร็จซ้ำ", value: 5 },
    { label: "ใบเสร็จไม่ถูกต้องตามเงื่อนไข", value: 6 },
    { label: "ใบเสร็จไม่อยู่ในระยะเวลาของกิจกรรม", value: 7 },
    { label: "ไม่เขียนชื่อ-นามสกุล", value: 8 },
    { label: "ชื่อที่ลงทะเบียนกับชื่อในใบเสร็จไม่ตรงกัน", value: 9 },
    { label: "ไม่ใช่ร้านค้าที่ร่วมรายการ", value: 10 },
    { label: "อื่นๆ ระบุ", value: 0 },
  ]);



  const buildDocumentValueDynamicField = () =>

    new Promise((resolve, reject) => {
      if (formData.information.payload.length <= 0) {
        return resolve([]);
      }

      const arrObj = formData.information.payload;
      const arrObjLength = formData.information.payload.length;
      arrObj.forEach((field, index) => {
        try {
          const property = vm.$refs[field.key + index][0];
          if (property) {
            field.value = property.fieldValue ?? field.value;
            if (formData.information.key.length < arrObjLength) {
              formData.information.key.push({
                key: field.key,
                value: String(field.value),
              });
            }
          }
        }
        catch { }
      });
      //console.log(arrObj)
      resolve(arrObj);
    });


  const fetchDocumentDetailFunc = () => {
    window.$loading(true);
    fetchDocumentDetail.payload.DocumentId = props.documentId;

    store
      .dispatch("api/apiRequest", fetchDocumentDetail)
      .then(async (resp) => {
        const respData = resp.data.payload;
        const daynamicInput = resp.data.dynamic_inputs;
        formData.containerId = respData.container_id;
        formData.documentId = respData.document_id;
        formData.status = respData.status;
        formData.statusLabel = respData.status_desc;
        formData.storeName = respData.store_name;
        formData.docType = respData.document_type;
        formData.docTypeLabel = respData.document_type_desc;
        formData.docDate = respData.documentdate
          ? formatDate(respData.documentdate)
          : "";
        formData.dateTime = respData.datetime
          ? formatDate(respData.datetime)
          : "";
        formData.docNo = respData.documentno;
        formData.receiptNo = respData.recieptno;
        // formData.orderDate = respData.name_th //รอค่าจาก api
        formData.mobileNo = respData.mobileno;
        formData.customerName = respData.name;
        formData.remark1 = respData.remark;
        formData.remark2 = respData.remark2;
        formData.itfRef1 = respData.itf_ref;
        formData.itfRef2 = respData.itf_ref_2;
        formData.itfExtra = respData.itf_extradata;
        formData.imageList =
          respData.attachments.length > 0
            ? respData.attachments.map((o) => ({
              seq: o.seq,
              imageId: o.attachmentid,
              imageUrl: o.image_url,
              rotate: 0,
            }))
            : [];
        formData.formId =
          Object.keys(daynamicInput).length > 0 ? daynamicInput.formid : 0;
        formData.information.payload =
          Object.keys(daynamicInput).length > 0 &&
            daynamicInput.fields?.length > 0
            ? daynamicInput.fields?.map((o) => ({
              fieldid: o.fieldid,
              api_key: o.key,
              field_property: {},
              key: o.key,
              label_en: o.field,
              label_th: o.field,
              placeholder_en: "",
              placeholder_th: "",
              required: o.required,
              seq: o.seq,
              type_desc: o.datatype != 20 ? "Textbox" : "Dropdown",
              type_id: o.datatype == 19 ? 19 : o.datatype == 20 ? 20 : o.datatype == 21 ? 21 : 1,
              value: o.value || "",
              disabled: false,
              type: o.datatype == 2 || o.datatype == 4 ? "number" : "text",
              opt_fields: o.opt_fields?.length > 0 ? o.opt_fields?.map((opt) => ({
                desc: opt.desc,
                fieldid: opt.fieldid,
                label: opt.stringvalue,
                value: opt.optionid,
                required: opt.required,
                seq: opt.seq,
                stringvalue: opt.stringvalue,
              })) : [],
              optionid: o.optionid,
              value_opt: o.value_opt,
              valueid: o.valueid,
              isdelete: false,
            }))
            : [];
        formData.information.key =
          daynamicInput.fields?.length > 0
            ? daynamicInput.fields?.map((o) => ({
              field: o.field,
              key: o.key,
              value: o.value || "",
            }))
            : [];
        formData.totalPoint = respData.total_point;
        formData.totalSpending = respData.total_spending;
        formData.reJectId = respData.rejectid;
        formData.rejectReason = respData.reject_reason;
        // formData.pointEarn = respData.point_earn
        if (respData.status !== 1) isConfirm.value = true;
      })
      .catch((err) => {
        openDefaultErrorModal();
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const formatDate = (dateStr) => {
    dateStr = String(dateStr).split(" ")[0];
    return dateStr.split("-").join("/");
  };

  const onChangeStatus = (form_status, to_status) => {
    window.$loading(true);
    const objPayload = {};
    const objPayloadOpts = [];

    if (formData.information.payload.length > 0) {
      formData.information.payload.forEach((o) => {
        if (o.type_id == 1) {
          objPayload[o.key] = String(o.value);
          return objPayload;
        }
        else if (o.type_id == 20 || o.type_id == 19 || o.type_id == 21) {
          objPayloadOpts.push({
            FieldId: o.fieldid,
            OptionId: o.optionid == null ? 0 : o.optionid,
            Value: o.value,
            ValueId: o.valueid == null ? 0 : o.valueid,
            Delete: o.isdelete
          });
        }
      });
    }

    const payload = {
      DocumentId: formData.documentId,
      DocumentNo: formData.docNo,
      RecieptNo: formData.receiptNo,
      StoreName: formData.storeName,
      Name: formData.customerName,
      MobileNo: formData.mobileNo,
      Remark: formData.remark1,
      Remark2: formData.remark2,
      ITF_Ref: formData.itfRef1,
      ITF_Ref_2: formData.itfRef2,
      ITF_ExtraData: formData.itfExtra,
      Total_Point: formData.totalPoint,
      Total_Spending: formData.totalSpending,
      RejectId: formData.reJectId,
      Reject_Reason: formData.rejectReason,
      From_Status: form_status,
      To_Status: to_status, // 1 pending 5 complete 9 reject
      FormId: formData.formId,
      // Point_Earn: formData.pointEarn,
      payload: objPayload,
      payload_Opts: objPayloadOpts,
    };
    fetchDocumentEdit.payload = payload;

    //console.log(fetchDocumentEdit.payload);
    store
      .dispatch("api/apiRequest", fetchDocumentEdit)
      .then(async (resp) => {
        const respData = resp.data.payload;
        vm.$emit("OnGetDocumentId", respData.document_id);
        fetchDocumentDetailFunc();

        openSuccessModal(null, null, null, () => {
          window.scrollToTop();
        });
        if (respData.status == 1) isConfirm.value = false;
      })
      .catch((err) => {
        openDefaultErrorModal();
      })
      .finally(() => {
        window.$loading(false);
        loading.save = false;
        loading.approve = false;
        loading.reject = false;
        loading.cancelProcess = false;
      });
  };

  const onNextButton = async () => {
    formData.information.payload = await buildDocumentValueDynamicField();
    isConfirm.value = true;
    vm.$emit("onFormData", formData, isConfirm);
  };

  const onBackButton = () => {
    if (formData.status !== 1) {
      setDefaultActiveTab();
      return router
        .replace("/campaign/list/document-detail/" + formData.containerId)
        .catch(() => { });
    }
    if (
      localStorage.getItem("activeTab") !== null &&
      localStorage.getItem("activeTab") == "0"
    ) {
      setDefaultActiveTab();
      return router
        .replace("/campaign/list/document-detail/" + formData.containerId)
        .catch(() => { });
    }
    return (isConfirm.value = false);
  };

  const setDefaultActiveTab = () => {
    ;
    localStorage.removeItem("activeTab");
  };

  const onApproveButton = async () => {
    loading.approve = true;
    if (formData.information.payload.length <= 0) {
      saveConfirmModal();
    } else {
      formData.information.payload = await buildDocumentValueDynamicField();
      openConfirmModal();
    }
  };

  const onRejectButton = () => {
    // Reject
    loading.reject = true;
    try {
      onChangeStatus(formData.status, 9);
    } catch { }
  };

  const onCancelApproveButton = () => {
    openCancelWarningModal();
  };

  const openCancelWarningModal = () => {
    openWarningModal(
      "ยกเลิกการทำรายการ",
      "ต้องการยกเลิกการทำรายการนี้หรือไม่",
      () => {
        onCancelButton();
      }
    );
  };

  const onCancelButton = () => {
    // Cancel
    loading.cancelProcess = true;
    try {
      onChangeStatus(formData.status, 1);
    } catch { }
  };

  const prevStep = () => {
    window.scrollToTop();
    vm.$emit("onPreviousStep");
  };

  const nextStep = () => {
    window.scrollToTop();
    vm.$emit("onNextStep");
  };

  const openConfirmModal = () => {
    modalType.confirm = true;
    openModal();
  };

  const closeConfirmModal = () => {
    loading.approve = false;
    modalType.confirm = false;
    closeModal();
  };

  const onSaveChange = async () => {
    //only save
    formData.information.payload = await buildDocumentValueDynamicField();
    try {
      onChangeStatus(formData.status, 1);
    } catch { }
  };

  const onNumberInput = (ev, dataValue) => {
    vm.$nextTick(() => {
      const inputNumber = ev.replace(/\D/g, "");
      formData[dataValue] = inputNumber;
    });
  };

  const saveConfirmModal = () => {
    // Approve
    try {
      onChangeStatus(formData.status, 5);
      closeConfirmModal();
    } catch { }
  };

  const openRejectModal = () => {
    modalType.reject = true;
    openModal();
  };

  const closeRejectModal = () => {
    modalType.reject = false;
    closeModal();
  };

  const onReject = (rejectData) => {
    let rejectObject = rejecOptionData.value.find(
      (element) => element.value == rejectData.reJectId
    );

    if (rejectObject.value == 0) {
      formData.rejectReason = rejectData.rejectReason;
    } else {
      formData.rejectReason = rejectObject.label;
    }

    loading.reject = true;
    try {
      onChangeStatus(formData.status, 9);
    } catch { }
    modalType.reject = false;
  };

  const onAddDropDown = (field, index) => {
    let add = {
      fieldid: field.fieldid,
      api_key: field.key,
      field_property: {},
      key: field.key,
      label_en: field.label_en,
      label_th: field.label_en,
      placeholder_en: "",
      placeholder_th: "",
      required: field.required,
      seq: field.seq,
      type_desc: field.type_desc,
      type_id: field.type_id,
      value: "",
      disabled: false,
      type: field.type,
      opt_fields: field.opt_fields,
      optionid: 0,
      value_opt: 0,
      valueid: 0,
      isdelete: false,
    }
    formData.information.payload.splice(index + 1, 0, add);
    //formData.information.payload.push(field);

    console.log(formData.information.payload);
  }

  const onRemoveDropDown = (field, index) => {
    if (field.valueid) {
      formData.information.payload.splice(index, 1);
      field.isdelete = true;
      formData.information.payload.push(field);
    }
    else {
      formData.information.payload.splice(index, 1);
    }
  }

  let Countfield = 1;

  const dynamicDropdownCondition = (field, type) => {
    const totalCountfield = formData.information.payload.filter((o) => o.fieldid == field.fieldid && o.isdelete == false).length;
    if (type == 'checkcount') {
      return totalCountfield
    }
    else {
      if (totalCountfield == Countfield) {
        Countfield = 1;
        return true
      }
      else {
        Countfield++;
        return false
      }
    }
  }

  onBeforeMount(() => {
    if (props.documentId) fetchDocumentDetailFunc();
  });

  watch(
    isConfirm,
    () => {
      if (isConfirm.value == true) return nextStep();
      return prevStep();
    },
    { deep: true }
  );

  watch(
    formData,
    () => {
      vm.$emit("onSetFormData", formData);
    },
    { deep: true }
  );

  // watch(
  //   formData,
  //   () => {
  //     if(formData.totalPoint) {
  //       return formData.pointEarn = formData.totalPoint * 2
  //     } else {
  //       return formData.pointEarn = 0
  //     }
  //   },
  //   { deep: true }
  // );

  return {
    formData,
    isConfirm,
    loading,
    modalType,
    resolveFields,
    resolveStatusLabel,
    resolveStatusClass,
    onNextButton,
    onCancelButton,
    onCancelApproveButton,
    onBackButton,
    onApproveButton,
    onRejectButton,
    openConfirmModal,
    closeConfirmModal,
    saveConfirmModal,
    onSaveChange,
    onNumberInput,
    rejecOptionData,
    onReject,
    openRejectModal,
    closeRejectModal,
    fetchDocumentDetailFunc,
    onRemoveDropDown,
    onAddDropDown,
    dynamicDropdownCondition,
  };
}
